/**
 * Checks if a string is a valid UUID format
 * @param str - The string to check
 * @returns true if the string matches UUID format, false otherwise
 */
function isUUID(str: string): boolean {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
}

export default isUUID;
